export const camelCaseToWords = (value) => {
  const converted = value.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return converted[0].toUpperCase() + converted.slice(1);
};

const reportTitleMap = {
  adherence30Days: 'Adherence 30 Days',
  yesterdaysStats: 'Yesterdays Statistics',
  interactive: 'Interactive Time',
  statusReport: 'Patient Status',
  ccmStatusReport: 'CCM Patient Status',
  'ccm-billing': 'CCM Billing',
  ccmInteractiveTime: 'CCM Interactive Time',
  ccmOnboardingStatus: 'CCM Onboarding Status',
  apcmEligibility: 'APCM Eligibility',
  patientEngagement: 'Patient Engagement',
};

export const formatReportTitle = (reportType) => {
  return reportTitleMap[reportType] ?? reportType;
};

export const generateMessage = (reportType) => {
  const result = formatReportTitle(reportType);
  return `Your ${camelCaseToWords(
    result,
  )} Report is ready for download. Please check email.`;
};

export const generateDownloadMessage = (reportType) => {
  const result = formatReportTitle(reportType);
  return `Your ${camelCaseToWords(result)} Report is ready. Click to download.`;
};
